import AbstractViewManage from '@/class/view/AbstractViewManage'
import { formatNumberToThousands } from '@/utils'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import * as LoadDefaultQueryParam from '@/utils/LoadDefaultQueryParam'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'
import { getBillingGroupList, simpleQueryBillingGroupList } from '@/api/clearing/billingNative'
import lodash from 'lodash'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import OperatorConstants from '@/class/cargo/model/parameters/OperatorConstants'
import { cacheName, cache } from '@/utils/cacheManager'
import * as SpecialFieldConstants from '@/utils/SpecialFieldConstants'
import * as BillingConstants from '@/class/cargo/model/parameters/BillingConstants'
import { getCacheListByKey } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import CustomLableUtils from '@/utils/CustomLabelUtils'
import * as AdvancedSearchConsts from '@/class/cargo/model/utils/AdvancedSearchConsts'
import { recordSelectedStatus } from '@/utils/agGrid'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import { BILLING_NOT_REVIEW, BILLING_REVIEW } from '@/class/cargo/model/parameters/BillingConstants'
import { stringToBool } from '@/utils/commonUtil'
import $store from '@/store'

export default class tabBillingGroupHP extends AbstractViewManage {
  constructor(view) {
    super(view)
  }

  // 通用显示列
  dynamicColumnDefs() {
    let columnDefs = [
      {
        headerName: '', width: 60, checkboxSelection: true,
        sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
        headerCheckboxSelection: true
      }
    ]
    columnDefs = [
      ...columnDefs,
      { headerName: this.$t('Billing.billingJob_accountStatementNo'), field: 'billingNo', width: 200, enableRowGroup: true },
      { headerName: this.$t('Billing.billingJob_settleAccountsTo'), field: 'accountId', width: 200,
        cellRenderer: (params) => {
          return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_accountId') : ''
        },
        enableRowGroup: true
      },
      { headerName: this.$t('Billing.billingJob_otherPartyBilling'), field: 'otherPartyBilling', width: 200, enableRowGroup: true },
      { headerName: this.$t('Billing.billingJob_creator'), field: 'inputBy', width: 200,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
        },
        enableRowGroup: true
      },
      { headerName: this.$t('Billing.billingView_billType'), field: 'billingType', width: 200,
        cellRenderer: (params) => {
          return ColumnUtils.billingTypeLabFun(params.value)
        },
        enableRowGroup: true
      },
      { headerName: this.$t('Billing.billingJob_invoiceHeader'), field: 'title', width: 200, enableRowGroup: true },
      { headerName: this.$t('Billing.billingJob_revenueAndExpenditureType'), field: 'ar', width: 200,
        cellRenderer: (params) => {
          return ColumnUtils.chargeReceivableLabelFun(stringToBool(params.value))
        },
        enableRowGroup: true
      },
      { headerName: this.$t('Billing.billingJob_confirmStatus'), field: 'state', width: 200,
        cellRenderer: (params) => {
          return ColumnUtils.billingStateLabelFun(Number(params.value))
        },
        enableRowGroup: true
      },
      { headerName: this.$t('Billing.billingJob_invoicingStatus'), field: 'invoiceState', width: 200,
        cellRenderer: (params) => {
          return ColumnUtils.invoiceStateLabelFun(Number(params.value))
        },
        hide: this._view.showColumnsVisible.showInvoiceState,
        enableRowGroup: true
      },
      { headerName: this.$t('Billing.billingJob_writeOffStatus_reconciliation'), field: 'realClearingState', width: 200,
        cellRenderer: (params) => {
          return ColumnUtils.clearingStateLabFun(Number(params.value))
        },
        hide: this._view.showColumnsVisible.showRealClearingState,
        enableRowGroup: true
      },
      { headerName: this.$t('Billing.billingJob_currency'), field: 'currency', width: 200, enableRowGroup: true },
      { headerName: this.$t('Billing.billingJob_amountOfMoney'), field: 'amount', width: 200,
        cellRenderer: (params) => {
          return formatNumberToThousands(ColumnUtils.number2ColumnLabelFunc(Number(params.value)), 2)
        },
        enableRowGroup: true,
        summaryMode: 'sum'
      },
      { headerName: this.$t('Billing.billingJob_notInvoicedMoney'), field: 'uninvoiceAmount', width: 200,
        cellRenderer: (params) => {
          return formatNumberToThousands(ColumnUtils.number2ColumnLabelFunc(Number(params.value)), 2)
        },
        hide: this._view.showColumnsVisible.showUnInvoiceAmount,
        enableRowGroup: true,
        summaryMode: 'sum'
      },
      { headerName: this.$t('CargoMsg.Cargo_TheAmountOfWrittenOff'), field: 'verifiedAmount', width: 200,
        cellRenderer: (params) => {
          return formatNumberToThousands(ColumnUtils.number2ColumnLabelFunc(Number(params.value)), 2)
        },
        hide: this._view.showColumnsVisible.showVerifiedAmount,
        enableRowGroup: true,
        summaryMode: 'sum'
      },
      { headerName: this.$t('Billing.billingAccount_invoicingInformation'), field: 'invoiceDetail', width: 200, enableRowGroup: true },
      { headerName: this.$t('Billing.billingJob_remarks'), field: 'remark', width: 200, enableRowGroup: true },
      { headerName: this.$t('Billing.billingJob_totalCurrency'), field: 'currencyAmount', width: 200, enableRowGroup: true,
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_InvoiceType'), field: 'invoiceType', colId: 'invoiceType', width: 120, hide: true, enableRowGroup: true },
      { headerName: this.$t('Invoice.invoice_invoiceCategory'), field: 'invoiceMakeType', colId: 'invoiceMakeType', width: 120, hide: true, enableRowGroup: true },
      {
        headerName: this.$t('Partners.isFba'),
        colId: 'fba',
        field: 'fba',
        width: 180,
        hide: true,
        valueFormatter: (params) => {
          return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
        },
        enableRowGroup: true
      },
      {
        headerName: this.$t('baseInfo.mailingAddress.fbaWarehouseCode'),
        colId: 'warehouseCode',
        field: 'warehouseCode',
        width: 180,
        hide: true,
        enableRowGroup: true
      },
      {
        headerName: this.$t('FbaJob.DestinationDistribution'),
        colId: 'destinationDistribution',
        field: 'destinationDistribution',
        width: 180,
        hide: true,
        valueFormatter: (params) => {
          return ColumnUtils.multipleFbaDestinationDistribution(TYPE_NAMES.local_cache_FbaJobConstants$DESTINATION_DISTRIBUTION_LIST, 'code', params.value)
        },
        enableRowGroup: true
      },
      {
        headerName: this.$t('FbaJob.ExpressNo'),
        colId: 'expressNo',
        field: 'expressNo',
        width: 180,
        hide: true,
        enableRowGroup: true
      },
      {
        headerName: this.$t('FbaJob.RemoteWarehouse'),
        colId: 'remoteWarehouse',
        field: 'remoteWarehouse',
        width: 180,
        hide: true,
        valueFormatter: (params) => {
          return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
        },
        enableRowGroup: true
      },
      {
        headerName: this.$t('FbaJob.ShipmentId'),
        colId: 'shipmentId',
        field: 'shipmentId',
        width: 180,
        hide: true,
        enableRowGroup: true
      },
      {
        headerName: this.$t('FbaJob.ReferenceId'),
        colId: 'referenceId',
        field: 'referenceId',
        width: 180,
        hide: true,
        enableRowGroup: true
      },
      {
        headerName: this.$t('CargoMsg.Cargo_DateOfDocument'), field: 'inputDate', colId: 'inputDate', width: 120, hide: true,
        cellRenderer: (params) => {
          return ColumnUtils.dateLabelFunc(params.value)
        },
        enableRowGroup: true
      }, {
        headerName: this.$t('CargoMsg.Carge_BillingGroupConfirmDate'),
        field: 'confirmDate',
        initialWidth: 200,
        cellRenderer: (params) => {
          return ColumnUtils.dateTimeLabelFunc(params.value)
        },
        enableRowGroup: true
      }, {
        headerName: this.$t('CargoMsg.Carge_BillingGroupConfirmUser'),
        field: 'confirmUser',
        initialWidth: 200,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
        },
        enableRowGroup: true
      },
      {
        headerName: this.$t('Payment.businessReferenceNumber'),
        colId: 'jobCustomerRefNo',
        field: 'jobCustomerRefNo',
        width: 150,
        enableRowGroup: true
      },
      {
        headerName: this.$t('Message.SettlementObjectAccountPeriod'),
        field: 'creditDateLimited',
        width: 100,
        hide: true,
        valueFormatter: params => {
          return ColumnUtils.AccountPeriodCommonLabelFunc(params.data)
        }
      },
      {
        headerName: this.$t('CargoMsg.Cargo_SettlementMethod'),
        field: 'creditDateType',
        width: 100,
        hide: true,
        valueFormatter: params => {
          return ColumnUtils.creditDateTypeCommonLabelFunc(params.data)
        }
      },
      {
        headerName: this.$t('CargoMsg.Cargo_CooperateBranchId'),
        colId: 'cooperatebranch',
        field: 'cooperatebranch',
        width: 160, minWidth: 160,
        hide: !this._view.useOrderCenterMode
      }, {
        headerName: this.$t('CargoMsg.Cargo_CooperateBusinessType'),
        colId: 'cooperateBusinessType',
        field: 'cooperateBusinessType',
        width: 200, minWidth: 200,
        hide: !this._view.useOrderCenterMode
      },
      {
        headerName: this.$t('CargoMsg.Cargo_Carrier'), field: 'jobCarrierId', width: 180,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
        },
        enableRowGroup: true
      },
      {
        headerName: this.$t('CargoMsg.Cargo_dispatchingPlace2'),
        field: 'jobDispatchingPlace',
        colId: 'jobDispatchingPlace',
        width: 120,
        enableRowGroup: true
      },
      {
        headerName: this.$t('CargoMsg.Cargo_actTakeTime'),
        field: 'actTakeTime',
        colId: 'actTakeTime',
        width: 120,
        cellRenderer: (params) => {
          return ColumnUtils.dateTimeLabelFunc(params.value)
        },
        enableRowGroup: true
      },
      { headerName: this.$t('Partners.ParentCompany'), field: 'globalAccountUuid', width: 200,
        cellRenderer: (params) => {
          return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'uuid', params.value, 'auto_accountId') : ''
        },
        enableRowGroup: true
      }, {
        headerName: this.$t('CargoMsg.Cargo_ApprovalStatus'),
        field: 'approvalStatus',
        width: 100,
        cellRenderer: (params) => {
          return ColumnUtils.approvalStatusLabelFun(Number(params.value))
        },
        hide: true,
        enableRowGroup: true
      }, {
        headerName: this.$t('CargoMsg.Cargo_StatementReviewStatus'),
        field: 'review',
        initialWidth: 100,
        cellRenderer: (params) => {
          return ColumnUtils.billingReviewLabelFunc(Number(params.value))
        },
        hide: true,
        enableRowGroup: true
      }, {
        headerName: this.$t('CargoMsg.Cargo_StatementReviewer'),
        field: 'reviewUser',
        initialWidth: 200,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
        },
        hide: true,
        enableRowGroup: true
      }, {
        headerName: this.$t('CargoMsg.Cargo_StatementReviewTime'),
        field: 'reviewDate',
        initialWidth: 250,
        cellRenderer: (params) => {
          return ColumnUtils.dateTimeLabelFunc(params.value)
        },
        hide: true,
        enableRowGroup: true
      },
      {
        headerName: this.$t('FinanceManage.CostType'),
        colId: 'costControlType',
        field: 'costControlType',
        width: 120,
        valueFormatter: (params) => {
          const isZh = $store.getters.language === 'zh'
          return ColumnUtils.resolveCostType(params.value, isZh ? 'chineseName' : 'englishName')
        },
        enableRowGroup: true
      },
      {
        headerName: this.$t('Message.SettlementObjectAccountCredit'),
        field: 'credit',
        width: 100,
        hide: true,
        cellRenderer: params => {
          return ColumnUtils.creditCommonLabelFunc(params.data)
        }
      }, {
        headerName: this.$t('FinanceManage.charge_notWhtAmount'),
        field: 'notWhtAmount',
        width: 100,
        hide: !this._view.showWhtTax,
        suppressColumnsToolPanel: !this._view.showWhtTax,
        valueFormatter: (params) => {
          return this._view.$numeral(params.data.notWhtAmount).format('0.00')
        }
      }, {
        headerName: this.$t('FinanceManage.charge_whtTaxAmount'),
        field: 'whtTaxLocalAmount',
        width: 100,
        hide: !this._view.showWhtTax,
        suppressColumnsToolPanel: !this._view.showWhtTax,
        valueFormatter: (params) => {
          return this._view.$numeral(params.value).format('0.00')
        }
      }
    ]

    return columnDefs
  }

  // 追加自定义查询条件
  async changeCustomSearchItems() {
    const defaultSearchFields = []
    // 对账单业务状态配置项
    const billingJobStates = await LoadDefaultQueryParam.getConfigQueryParam(this._view.searchConditions.billingGroupJobStateParam, SystemConstants.JOB_STATES)
    if (billingJobStates && billingJobStates.length > 0) {
      const searchField = new AdvancedSearchField()
      searchField.itemType = 'select'
      searchField.multiple = 1
      searchField.itemValue = []
      searchField.itemLabel = 'Billing.billingCharge_businessStatus'
      searchField.itemName = 'job.JOB_STATE'
      searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
      searchField.dataProvider = billingJobStates
      defaultSearchFields.push(searchField.formatObj2Json())
    }
    // CARGO-37600 H5 BUG 筛选条件保存多个无法保存成功
    // // 对账单确认人
    // const searchField = new AdvancedSearchField()
    // searchField.action = AdvancedSearchField.UPDATE_ACTION
    // searchField.itemType = 'advanceSelect'
    // searchField.fieldType = 'FIELD_DROP_DOWN_LIST'
    // searchField.itemName = 'billingGroup.CONFIRM_USER'
    // searchField.itemLabel = 'CargoMsg.Carge_BillingGroupConfirmUser'
    // searchField.tagValue = 'userId'
    // searchField.defaultSelected = 0
    // searchField.subType = { filterable: true }
    // searchField.dataProvider = getCacheListByKey(basicCacheKeys.basic_data_User)
    // defaultSearchFields.push(searchField.formatObj2Json())
    if (this._view.useOrderCenterMode) {
      const officeAll = getCacheListByKey(basicCacheKeys.basic_data_Office_All)
      const offices = officeAll.filter(p => p.code !== 'HQ').sort((office1, office2) => office1.officeId > office2.officeId ? 1 : -1)
      offices.forEach(row => { row.code = row.officeId }) // ID
      let searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.ADD_ACTION
      searchField.itemType = 'select'
      searchField.multiple = 1
      searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_IN]
      searchField.defaultConditionVal = 0
      searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
      searchField.itemName = 'cooperate.BRANCH_ID'
      searchField.itemLabel = 'CargoMsg.Cargo_CooperateBranchId'
      searchField.itemValue = []
      searchField.tagValue = 'officeId'
      searchField.defaultSelected = 1
      searchField.selected = 0
      searchField.dropdownDataRef = ''
      searchField.lock = false
      searchField.defaultValue = []
      searchField.dataProvider = offices
      defaultSearchFields.push(searchField.formatObj2Json())
      // 协作业务类型
      const cooperationTypes = getCacheListByKey(basicCacheKeys.basic_data_CooperationType)
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.ADD_ACTION
      searchField.itemType = 'select'
      searchField.multiple = 1
      searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_IN]
      searchField.defaultConditionVal = 0
      searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
      searchField.itemName = 'cooperate.BUSINESS_TYPE'
      searchField.itemLabel = 'CargoMsg.Cargo_CooperateBusinessType'
      searchField.itemValue = []
      searchField.defaultSelected = 1
      searchField.selected = 0
      searchField.dropdownDataRef = ''
      searchField.lock = false
      searchField.defaultValue = []
      searchField.dataProvider = cooperationTypes
      defaultSearchFields.push(searchField.formatObj2Json())
    }
    if (this._view.useOrderCenterMode) {
      const officeAll = getCacheListByKey(basicCacheKeys.basic_data_Office_All)
      const offices = officeAll.filter(p => p.code !== 'HQ').sort((office1, office2) => office1.officeId > office2.officeId ? 1 : -1)
      offices.forEach(row => { row.code = row.officeId }) // ID
      let searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.ADD_ACTION
      searchField.itemType = 'select'
      searchField.multiple = 1
      searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_IN]
      searchField.defaultConditionVal = 0
      searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
      searchField.itemName = 'cooperate.BRANCH_ID'
      searchField.itemLabel = 'CargoMsg.Cargo_CooperateBranchId'
      searchField.itemValue = []
      searchField.tagValue = 'officeId'
      searchField.defaultSelected = 1
      searchField.selected = 0
      searchField.dropdownDataRef = ''
      searchField.lock = false
      searchField.defaultValue = []
      searchField.dataProvider = offices
      defaultSearchFields.push(searchField.formatObj2Json())
      // 协作业务类型
      const cooperationTypes = getCacheListByKey(basicCacheKeys.basic_data_CooperationType)
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.ADD_ACTION
      searchField.itemType = 'select'
      searchField.multiple = 1
      searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_IN]
      searchField.defaultConditionVal = 0
      searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
      searchField.itemName = 'cooperate.BUSINESS_TYPE'
      searchField.itemLabel = 'CargoMsg.Cargo_CooperateBusinessType'
      searchField.itemValue = []
      searchField.defaultSelected = 1
      searchField.selected = 0
      searchField.dropdownDataRef = ''
      searchField.lock = false
      searchField.defaultValue = []
      searchField.dataProvider = cooperationTypes
      defaultSearchFields.push(searchField.formatObj2Json())
    }
    if (this.$checkPermission(['role_ViewHierarchicalListAtFinancial']) || this.$checkPermission(['role_ViewHierarchicalDetailAtFinancial'])) {
      JobUtils.configSearchItemsChildOffice(this._view.defaultSearchItems, defaultSearchFields)
    }
    if (defaultSearchFields && defaultSearchFields.length > 0) {
      this._view.customSearchItems = defaultSearchFields
    }

    if (this._view.viewSource === 'tabMakeInvoice') {
      await cache.load(cacheName.CONFIG)
      const param = cache.config.get('InvoiceBillingGroupState')
      if (!param) {
        this._view.searchConditions.billingGroupStates = BillingConstants.BILLING_STATES
        this._view.searchConditions.billingGroupReviewStates = BillingConstants.BILLING_REVIEW
        return
      }
      const states = param.split(',')
      const result = []
      const reviewStates = []
      if (states && states.length > 0) {
        for (let i = 0; i < states.length; i++) {
          if (Number(states[i]) === 2) {
            // 已复核
            reviewStates.push(BillingConstants.BILLING_REVIEWED)
          } else if (Number(states[i]) === 3) {
            // 未复核
            reviewStates.push(BillingConstants.BILLING_NOT_REVIEW)
          } else {
            const commonState = CommonState.getStateByCode(BillingConstants.BILLING_STATES, Number(states[i]))
            if (commonState) {
              result.push(commonState)
            }
          }
        }
      }
      this._view.searchConditions.billingGroupStates = result
      this._view.searchConditions.billingGroupReviewStates = reviewStates
    }
  }

  // 列表查询触发（高级conditions是查询条件/快捷检索conditions代表是键盘输入的值）
  fetchData({ simpleTriggerMode, conditions }) {
    const finallyConditions = []
    if (simpleTriggerMode) {
      if (this._view.viewSource === 'tabBillingGroup') {
        this._view.appendQuery = false
        const option = new AdvancedSearchOption(null, 'billingGroup.BILLING_NO', conditions.trim(), OperatorConstants.OPERATOR_LIKE.code)
        finallyConditions.push(option.formatObj2Json())
      }
    } else {
      // 高级查询条件组装
      if (conditions && conditions.length > 0) {
        const advConditions = lodash.cloneDeep(conditions)
        // 获取追加查询条件
        this._view.appendQuery = JobUtils.appendQueryCondition(advConditions)
        finallyConditions.push(...advConditions)
      }
    }
    this._view.showLoading = true
    if (this._view.viewSource === 'tabBillingGroup') {
      this._view.searchConditions.snapshotConditionsBillingGroup = lodash.cloneDeep(finallyConditions)
    } else {
      if (this._view.pageMode === 0) {
        this._view.searchConditions.snapshotConditionsBillingGroup = lodash.cloneDeep(finallyConditions)
      } else {
        this._view.searchConditionsHedge.snapshotConditionsBillingGroup = lodash.cloneDeep(finallyConditions)
      }
    }
    this.toAdvQueryList(finallyConditions, simpleTriggerMode)
  }
  // 查看事件
  async toAdvQueryList(conditions, simpleTriggerMode = false, isUpdate = false, queryMasterDb = false) {
    this._view.queryOfficeId = this.$store.getters.currentOfficeId
    await cache.load(cacheName.CONFIG)
    // 拼接默认的查询条件
    let searchConditions = []
    if (this._view.viewSource === 'tabBillingGroup') {
      searchConditions = this._view.searchConditions
    } else {
      if (this._view.pageMode === 0) {
        searchConditions = this._view.searchConditions
      } else {
        searchConditions = this._view.searchConditionsHedge
      }
    }
    let inputDate = ''
    if (searchConditions.inputDateStart && searchConditions.inputDateEnd) {
      inputDate = 'start=' + searchConditions.inputDateStart + ' 00:00:00' + ',end=' + searchConditions.inputDateEnd + ' 23:59:59'
    } else if (searchConditions.inputDateStart && !searchConditions.inputDateEnd) {
      inputDate = 'start=' + searchConditions.inputDateStart + ' 00:00:00'
    } else if (!searchConditions.inputDateStart && searchConditions.inputDateEnd) {
      inputDate = 'end=' + searchConditions.inputDateEnd + ' 23:59:59'
    }
    if (inputDate) {
      const condition = new AdvancedSearchOption(null, 'billingGroup.INPUT_DATE', inputDate + ',type=date', OperatorConstants.OPERATOR_RANGE.code)
      conditions.push(condition.formatObj2Json())
    }
    // 内结
    if (searchConditions.internalCharge) {
      const condition = new AdvancedSearchOption(null, 'charge.INTERNAL', true, OperatorConstants.OPERATOR_EQUAL.code)
      conditions.push(condition.formatObj2Json())
    }
    if (searchConditions.paymentType !== -1) {
      const condition = new AdvancedSearchOption(null, 'billingGroup.AR', searchConditions.paymentType === 1, OperatorConstants.OPERATOR_EQUAL.code)
      conditions.push(condition.formatObj2Json())
    }
    if (searchConditions.advance !== -1) {
      const condition = new AdvancedSearchOption(null, 'charge.ADVANCE', searchConditions.advance === 1, OperatorConstants.OPERATOR_EQUAL.code)
      conditions.push(condition.formatObj2Json())
    }
    if (searchConditions.isNeedInvoice !== -1) {
      const condition = new AdvancedSearchOption(null, 'charge.NEED_INVOICE', searchConditions.isNeedInvoice === 1, OperatorConstants.OPERATOR_EQUAL.code)
      conditions.push(condition.formatObj2Json())
    }
    if (searchConditions.hasInvoice !== -1 && !AdvancedSearchOption.hasField(SpecialFieldConstants.BILLING_GROUP_INVOICE_STATE2, conditions) && !AdvancedSearchOption.hasField('invoice.INVOICEDATE', conditions)) {
      const operator = searchConditions.hasInvoice === 0 ? OperatorConstants.OPERATOR_IS_NULL.code : OperatorConstants.OPERATOR_IS_NOT_NULL.code
      const condition = new AdvancedSearchOption(null, 'charge.INVOICE_UUID', null, operator)
      conditions.push(condition.formatObj2Json())
    }
    if (searchConditions.billingGroupStates && searchConditions.billingGroupStates.length > 0 && !AdvancedSearchOption.hasField('billingGroup.STATE', conditions)) {
      const billingGroupStateArray = LoadDefaultQueryParam.convertCommonStateToInt(searchConditions.billingGroupStates)
      const condition = new AdvancedSearchOption(null, 'billingGroup.STATE', billingGroupStateArray, OperatorConstants.OPERATOR_IN.code)
      conditions.push(condition.formatObj2Json())
    }
    if (searchConditions.billingGroupReviewStates && searchConditions.billingGroupReviewStates.length > 0 && !AdvancedSearchOption.hasField('billingGroup.REVIEW', conditions)) {
      const billingGroupReviewStateArray = LoadDefaultQueryParam.convertCommonStateToInt(searchConditions.billingGroupReviewStates)
      const condition = new AdvancedSearchOption(null, 'billingGroup.REVIEW', billingGroupReviewStateArray, OperatorConstants.OPERATOR_IN.code)
      conditions.push(condition.formatObj2Json())
    }
    if (searchConditions.billingGroupJobStates && searchConditions.billingGroupJobStates.length > 0 && !AdvancedSearchOption.hasField('job.JOB_STATE', conditions)) {
      const billingJobStateArray = LoadDefaultQueryParam.convertCommonStateToInt(searchConditions.billingGroupJobStates)
      const condition = new AdvancedSearchOption(null, 'job.JOB_STATE', billingJobStateArray, OperatorConstants.OPERATOR_IN.code)
      conditions.push(condition.formatObj2Json())
    }
    if (searchConditions.selectedEntitiesForHedging && searchConditions.selectedEntitiesForHedging.length > 0) {
      const condition = new AdvancedSearchOption(null, 'selectedEntitiesForHedging', searchConditions.selectedEntitiesForHedging)
      conditions.push(condition.formatObj2Json())
    }
    if (searchConditions.chargeTypeGroup > -1) {
      const code = (searchConditions.chargeTypeGroup === 0) ? BillingConstants.BILLING_TYPE_INTERNAL.code : BillingConstants.BILLING_TYPE_OVERSEA.code
      const condition = new AdvancedSearchOption(null, 'billingGroup.BILLING_TYPE', code, OperatorConstants.OPERATOR_EQUAL.code)
      conditions.push(condition.formatObj2Json())
    }
    if (searchConditions.billingGroupClearingState !== -1) {
      const condition = new AdvancedSearchOption(null, 'charge.PAID_OFF', searchConditions.billingGroupClearingState === 1, OperatorConstants.OPERATOR_EQUAL.code)
      conditions.push(condition.formatObj2Json())
    }
    if (searchConditions.exceptKeys.length > 0) {
      const condition = new AdvancedSearchOption(null, 'billingGroup.UUID', searchConditions.exceptKeys, OperatorConstants.OPERATOR_NOT_IN.code)
      conditions.push(condition.formatObj2Json())
    }
    // 内结
    if (searchConditions.internalCharge) {
      const condition = new AdvancedSearchOption(null, 'charge.INTERNAL', true, OperatorConstants.OPERATOR_EQUAL.code)
      conditions.push(condition.formatObj2Json())
    }
    // 是否查询受控费用
    if (!this.showControlledCharge) {
      // 是否有应付受控费用权限
      const isControlled = this.$checkPermission(['button_Charge_controlled'])
      // 是否有应收受控费用权限
      const isCostControlled = this.$checkPermission(['button_Charge_costControlled'])
      let value = 0
      if (!isControlled && !isCostControlled) {
        value = 1
      } else if (!isControlled) {
        value = 2
      } else if (!isCostControlled) {
        value = 3
      }
      if (value !== 0) {
        const option = new AdvancedSearchOption(null, 'cIsControlled', value, OperatorConstants.OPERATOR_EQUAL.code)
        conditions.push(option.formatObj2Json())
      }
    }
    const requires = []
    if (!this._view.showColumnsVisible.showVerifiedAmount) { requires.push('writeoff') }
    if (!this._view.showColumnsVisible.showInvoiceState || !this._view.showColumnsVisible.showUnInvoiceAmount) { requires.push('invoice') }
    if (!this._view.showColumnsVisible.showFba) { requires.push('fba') }

    const requestBody = { conditions, requires: requires, branchId: this.$store.getters.currentOfficeId }
    if (this._view.viewSource === 'tabBillingGroup') { // 对账单查询时要加权限
      requestBody.pageNum = this._view.searchConditions.pageNum
      requestBody.pageSize = this._view.searchConditions.pageSize
      requestBody.hasCheckRole = true
    } else { // 其他查询对账单不加权限
      requestBody.hasCheckRole = false
      if (this._view.pageMode === 0) {
        requestBody.pageNum = this._view.searchConditions.pageNumBillingGroupGrid
        requestBody.pageSize = this._view.searchConditions.pageSize
      } else {
        requestBody.pageNum = this._view.searchConditionsHedge.pageNumBillingGroupGrid
        requestBody.pageSize = this._view.searchConditionsHedge.pageSize
      }
    }
    requestBody.queryMasterDb = queryMasterDb || false
    this.loading()
    if (simpleTriggerMode) { // 快捷查询
      const selectedStatus = recordSelectedStatus(this._view.gridOptions.api, 'uuid')
      simpleQueryBillingGroupList(requestBody).then(res => {
        if (this._view.viewSource === 'tabBillingGroup') {
          this.handleBillingGroupResult(res)
        } else {
          this.handleInvoiceResult(res)
        }
        selectedStatus.revert()
      }).finally(() => {
        this.closeLoading()
      })
    } else {
      requestBody.appendQuery = this._view.appendQuery
      const selectedStatus = recordSelectedStatus(this._view.gridOptions.api, 'uuid')
      getBillingGroupList(requestBody).then(res => {
        if (this._view.viewSource === 'tabBillingGroup') {
          this.handleBillingGroupResult(res, isUpdate)
        } else {
          this.handleInvoiceResult(res)
        }
        selectedStatus.revert()
      }).finally(() => {
        this.closeLoading()
      })
    }
  }

  // 对账新版-对账单-高级查询返回结果集处理
  handleBillingGroupResult(res, isUpdate = false) {
    let results = res.data.list
    if (results && results.length > 0) {
      // 追加查询数据去重
      if (this._view.appendQuery) {
        results = JobUtils.appendQueryRepeat(this._view.rowData, results, this._view.appendQuery)
      }
      if (isUpdate) {
        const { rowsToDisplay } = this._view.gridOptions.api.getModel()
        rowsToDisplay.forEach(node => {
          node.setSelected(false)
          const { data } = node
          const newData = results.find(row => row.uuid === data.uuid)
          if (newData) {
            node.setData(newData)
          } else {
            this._view.gridOptions.api.updateRowData({ remove: [node.data] })
          }
        })
        results.forEach(item => {
          const newData = rowsToDisplay.find(row => row.data.uuid === item.uuid)
          if (!newData) {
            this._view.gridOptions.api.updateRowData({ add: [item] })
          }
        })
      } else {
        this._view.rowData = results
      }
      if (this._view.searchConditions.paymentType === -1) {
        this._view.totalAmountToCurrency.labelText = this.$t('Message.All2')
      } else if (this._view.searchConditions.paymentType === 0) {
        this._view.totalAmountToCurrency.labelText = this._view.$t('Clearing.Payable')
      } else if (this._view.searchConditions.paymentType === 1) {
        this._view.totalAmountToCurrency.labelText = this._view.$t('Clearing.Receivable')
      }
      this._view.totalAmountToCurrency.dataProvider = results
    } else {
      // 如果是追加查询的话就不走下面的清空代码
      if (this._view.appendQuery) return
      this._view.rowData = []
      this._view.totalAmountToCurrency.dataProvider = []
    }
    this._view.searchConditions.total = this._view.appendQuery ? results.length : Number(res.data.total)
  }
  // 开票-按对账单查询结果集处理
  handleInvoiceResult(res) {
    let results = res.data.list
    if (results && results.length > 0) {
      if (this._view.pageMode === 0) {
        // 追加查询数据去重
        if (this._view.appendQuery) {
          results = JobUtils.appendQueryRepeat(this._view.billingGroupGrid.rowData, results, this._view.appendQuery)
        }
        this._view.billingGroupGrid.rowData = results
        this._view.searchConditions.totalBillingGroupGrid = this._view.appendQuery ? results.length : Number(res.data.total)

        this._view.totalAmountToCurrencyBillingGroupGrid.dataProvider = this._view.billingGroupGrid.rowData
        this._view.totalAmountToCurrencyBillingGroupGrid.selectedCount = 0
      } else {
        // 追加查询数据去重
        if (this._view.appendQuery) {
          results = JobUtils.appendQueryRepeat(this._view.billingGroupGridHedge.rowData, results, this._view.appendQuery)
        }
        this._view.billingGroupGridHedge.rowData = results
        this._view.searchConditionsHedge.totalBillingGroupGrid = this._view.appendQuery ? results.length : Number(res.data.total)

        this._view.totalAmountToCurrencyBillingGroupGridHedge.dataProvider = this._view.billingGroupGridHedge.rowData
        this._view.totalAmountToCurrencyBillingGroupGridHedge.selectedCount = 0
      }
    } else {
      if (this._view.appendQuery) return // 如果是追加查询的话就不走下面的清空代码
      if (this._view.pageMode === 0) {
        this._view.billingGroupGrid.rowData = []
        this._view.searchConditions.totalBillingGroupGrid = 0

        this._view.totalAmountToCurrencyBillingGroupGrid.dataProvider = []
        this._view.totalAmountToCurrencyBillingGroupGrid.selectedCount = 0
      } else {
        this._view.billingGroupGridHedge.rowData = []
        this._view.searchConditionsHedge.totalBillingGroupGrid = 0

        this._view.totalAmountToCurrencyBillingGroupGridHedge.dataProvider = []
        this._view.totalAmountToCurrencyBillingGroupGridHedge.selectedCount = 0
      }
    }
  }
}
